export default __webpack_public_path__ + "static/media/icon-stores.df2f52ea.jpg";